import {
  BOOKING_INQUIRY_ENABLE_LOADING,
  BOOKING_INQUIRY_DISABLE_LOADING,
  BOOKING_INQUIRY_SET_FILTER,
  BOOKING_INQUIRY_APPLY_FILTER,
  BOOKING_INQUIRY_GET_STATUS_WISE_COUNT,
  BOOKING_INQUIRY_PAGINATION,
  BOOKING_INQUIRY_RESET_FILTER,
  BOOKING_INQUIRY_SET_PREV_PAGINATION,
  BOOKING_INQUIRY_UPDATE_DATA,
  BOOKING_INQUIRY_CANCEL_FILTER,
} from 'src/actions/constants';

const defaultFilters = {
  status: 'ALL',
  sortBy: 'created_at',
  searchType: 'BOOKING',
  descendingOrder: true,
  polList: [],
  podList: [],
  typeList: [],
  modeList: [],
  polSearch: 'port',
  podSearch: 'port',
  originCityList: [],
  destinationCityList: [],
  originCountryList: [],
  destinationCountryList: [],
};

const defaultState = {
  selectedFilters: {
    ...defaultFilters,
  },
  appliedFilters:  {
    ...defaultFilters,
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  prevPagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case BOOKING_INQUIRY_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case BOOKING_INQUIRY_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case BOOKING_INQUIRY_SET_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case BOOKING_INQUIRY_CANCEL_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.appliedFilters,
        },
      };
    }

    case BOOKING_INQUIRY_APPLY_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };
    }

    case BOOKING_INQUIRY_GET_STATUS_WISE_COUNT: {
      return {
        ...state,
        statusWiseBookingCount: action.data,
      };
    }

    case BOOKING_INQUIRY_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }

    case BOOKING_INQUIRY_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case BOOKING_INQUIRY_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }

    case BOOKING_INQUIRY_UPDATE_DATA: {
      return {
        ...state,
        bookingData: action.data ? action.data.data : [],
        prevPagination: {
          ...state.pagination,
        },
        pagination: {
          ...state.pagination,
          currentPageNumber: action.data && action.data.currentPageNumber,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          isNextPresent: action.data && action.data.isNextPresent,
          nextOrPrev: action.data && action.data.nextOrPrev,
        },
      };
    }
    default: {
      return state;
    }
  }
}
